import {FONT_ALLOWLIST, fontPreloadLinks} from "~/shared/fonts";

export default defineNuxtPlugin((nuxtApp) => {
    const settingsStore = useSettingsStore()
    const { createThemeColors } = useDesign()

    const cssVars = computed(() => createThemeColors(settingsStore.settings?.colors || {}))

  const font=settingsStore.settings?.font || 'manrope';

  const fontSize=(settingsStore.settings?.font_size || '16') + 'px';
  const fontKey = font in FONT_ALLOWLIST ? font : 'manrope';
  const fontFamily=FONT_ALLOWLIST[fontKey]!.family;

  useHead(() => {
    const vars = { ...cssVars.value }
    vars["--font-base"] = fontSize;
    vars["--el-font-size-base"] = fontSize;
    vars["--font-family"] = fontFamily;
    vars["--img-ratio"] = settingsStore.settings?.img_ratio || '4/3';
    vars["--img-product-page-fill"] = settingsStore.settings?.img_product_page_fill || 'contain';

    const style = Object.entries(vars)
      .map(([k, v]) => `${k}: ${v};`)
      .join(' ')
    return {
      link: fontPreloadLinks(fontKey, String(nuxtApp.$i18n.locale.value || nuxtApp.$i18n.defaultLocale)),
      htmlAttrs: {
        style,
        // Existing sites without this setting keep their current button styles.
        'data-custom-primary-button-text': settingsStore.settings?.colors?.primary_button_text?.trim() ? 'true' : undefined,
      },
    }
  })
})
